import * as helpers from '../helpers';
import Dropdown from './dropdown';
import FixedElement from './fixed-element';
import sameCategory from '../../components/same-category/same-category';

// Duplicate functionality on page and in popup
export default function partialCore() {
    sameCategory();
    const drop = new Dropdown();

    const mainWrapInit = document.querySelector('.site-inner');
    const elementInit = document.querySelector('.sidebar-content');

    if (mainWrapInit && elementInit) {
        const mainWrapHeightInit = mainWrapInit.getBoundingClientRect().height;
        const elementHeightInit = elementInit.getBoundingClientRect().height;

        if (window.innerWidth > 1338 && mainWrapHeightInit > elementHeightInit + 200) {
            const summary = FixedElement.create('.sidebar-content', {
                addPlaceholderElement: false,
                onScroll: (instance) => {
                    const mainWrap = helpers.findAncestor(instance.element, 'site-inner');
                    const mainWrapHeight = mainWrap.getBoundingClientRect().height;
                    const elementHeight = instance.height;
                    if (mainWrapHeight > elementHeight && instance.lastScrollPosition - elementHeight + 640 >= mainWrapHeight) {
                        instance.element.classList.add('js-fixed-el-bottom');
                    } else {
                        instance.element.classList.remove('js-fixed-el-bottom');
                    }
                },
            });
        }
    }

    const sameCategoryWrapper = document.querySelector('.same-category__wrapper:not(.-is-initialized)');

    if (sameCategoryWrapper !== null) {
        const categoryWrapper = new Dropdown(sameCategoryWrapper, {
            wrapperClass: 'same-category__wrapper',
            dropdownClass: 'same-category__list',
            btnClass: 'same-category__toggle',
            closeOnOutsideClick: false,
        });
    }

    const figureWithCaptions = [...document.querySelectorAll('.js-figure')];

    if (figureWithCaptions.length) {
        figureWithCaptions.forEach((item) => {
            const figcaptionToggle = item.querySelector('.js-caption-toggle');
            const figcaption = item.querySelector('.js-caption');

            if (figcaptionToggle) {
                figcaptionToggle.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    figcaption.classList.toggle('-hide');
                });
            }
        });
    }
}
